export default "__VITE_ASSET__VM190bsW__"